import React from "react";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import SendButton from "./SendButton";
import securedletter from "../../icons/secured-letter.png";
import comments from "../../icons/comments.png";
import "./iconinput.css";

const chooseIcon = type => {
  switch (type) {
    case "Email":
      return <img src={securedletter} height="40px" alt="" />;
    case "Text":
      return <img src={comments} height="40px" alt="" />;
    default:
  }
};

export default class InputWithIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: ""
    };
  }

  handleChange(event) {
    this.setState({ input: event.target.value });
  }

  render() {
    return (
      <div className="input-and-icon">
        <FormControl fullWidth>
          <Input
            id="input-with-icon-adornment"
            placeholder={this.props.type + " Pill Cards"}
            disableUnderline={true}
            value={this.state.input}
            onChange={this.handleChange.bind(this)}
            startAdornment={
              <InputAdornment position="start">
                {chooseIcon(this.props.type)}
              </InputAdornment>
            }
          />
        </FormControl>
        <SendButton
          name="Send"
          type={this.props.type}
          val={this.state.input}
          url={this.props.url}
          changes={this.props.changes}
          confirmHandler={this.props.confirmHandler}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NavBar/SendDialog/InputWithIcon.js